const clean = (value, length) => String(value || '').trim().slice(0, length);

export const buildAssistBody = (sheet, focusedLine, move, extra = {}) => {
  const sections = sheet?.sections || [];
  const sectionIndex = Number.isInteger(focusedLine?.section) ? focusedLine.section : 0;
  const section = sections[sectionIndex] || sections[0] || { label: 'Hook', lines: [] };
  const lineIndex = Number.isInteger(focusedLine?.line) ? focusedLine.line : -1;
  const activeLine = lineIndex >= 0 ? section.lines?.[lineIndex] : null;
  const before = lineIndex > 0
    ? (section.lines || [])
      .slice(0, lineIndex)
      .map((line) => clean(line.text, 140))
      .filter(Boolean)
      .slice(-4)
    : [];
  const body = {
    move,
    section: section.label || 'Hook',
    line: clean(activeLine?.text, 140),
    before,
    vibe: clean(sheet?.vibe, 40),
  };
  if (move === 'rhymes_that_mean') {
    body.target_word = clean(extra.target_word, 40);
    body.meaning = clean(extra.meaning, 80);
  }
  return body;
};
